/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum OffertStatus {
    Angefragt = 'Angefragt',
    Hochgeladen = 'Hochgeladen',
    Verglichen = 'Verglichen',
    Akzeptiert = 'Akzeptiert',
    Abgelehnt = 'Abgelehnt'
  }

    export const OffertStatusTranslocoMap: Record<OffertStatus, string> = {
    [OffertStatus.Angefragt]: 'offertStatus.angefragt',
    [OffertStatus.Hochgeladen]: 'offertStatus.hochgeladen',
    [OffertStatus.Verglichen]: 'offertStatus.verglichen',
    [OffertStatus.Akzeptiert]: 'offertStatus.akzeptiert',
    [OffertStatus.Abgelehnt]: 'offertStatus.abgelehnt',
    };

    export const OffertStatusOptions = [
  { value: OffertStatus.Angefragt, labelKey: 'offertStatus.angefragt' },
  { value: OffertStatus.Hochgeladen, labelKey: 'offertStatus.hochgeladen' },
  { value: OffertStatus.Verglichen, labelKey: 'offertStatus.verglichen' },
  { value: OffertStatus.Akzeptiert, labelKey: 'offertStatus.akzeptiert' },
  { value: OffertStatus.Abgelehnt, labelKey: 'offertStatus.abgelehnt' },
    ];

